
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/en/faq",
      function () {
        return require("private-next-pages/de/en/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/en/faq"])
      });
    }
  